/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { baseUrlApi } from './base';

export const getParametrage = () => `${baseUrlApi}/parametrages`;
export const createParametresGeneraux = () => `${baseUrlApi}/parametrages`;
export const updateParametresGeneraux = (identifiant) =>
  `${baseUrlApi}/parametrages/${identifiant}`;
export const downloadFileParametragesGeneraux = (identifiant, name) =>
  `${baseUrlApi}/parametrages/${identifiant}/${name}/download`;
export const uploadFileParametragesGeneraux = (identifiant, name) =>
  `${baseUrlApi}/parametrages/${identifiant}/${name}/upload`;
